export const SPACES = {
  lobby: {
    name: 'Lobby',
    tasks: [
      {
        text: 'Play music',
        resultText: '"Billie Jean is not my lover..."',
        effects: [{ target: 'playMusic', value: true }],
      },
    ],
    nextSpaces: [{ name: 'managerSpace' }, { name: 'workingSpace' }],
    texts: ['What are all these trophies...?'],
  },
  managerSpace: {
    name: 'Manager space',
    tasks: [
      {
        text: 'Talk to Hans',
        resultText: '"Nice to see somebody here, finally! I came here like 6:30 AM. Yeah, it\'s crazy late..."',
      },
    ],
    nextSpaces: [{ name: 'lobby' }, { name: 'realKitchen' }, { name: 'workingSpace' }],
    texts: ["Hmm... I don't see anybody coding here. Maybe I should find my desk?"],
  },
  realKitchen: {
    name: 'Real Kitchen',
    tasks: [
      {
        text: 'Eat a candy bar',
        resultText: 'This really gives me some boost!',
      },
      {
        text: 'Make Folgers',
        condition: { target: 'makeCoffee', value: false },
        effects: [{ target: 'makeCoffee', value: true }],
        resultText: "I just press this button and soon I'll have a perfect cup of Folgers...",
      },
      {
        text: 'Drink coffee',
        condition: { target: 'makeCoffee', value: true },
        effects: [{ target: 'drinkCoffee', value: true }],
        resultText: 'That tasted absolutely awesome!',
      },
    ],
    nextSpaces: [{ name: 'managerSpace' }],
    texts: ['That coffee machine looks awesome!'],
  },
  workingSpace: {
    name: 'Working Space',
    tasks: [
      {
        text: 'Give leftovers to Elton',
        condition: { target: 'takeLeftovers', value: true },
        effects: [{ target: 'feedElton', value: true }],
        resultText: '"I just ate 5 hamburgers but there\'s always space for some dessert, man!" - Elton',
      },
      {
        text: 'Do some coding',
        effects: [{ target: 'code', value: true }],
        resultText: 'Mmmm...',
      },
      {
        text: 'Do some more coding',
        condition: { target: 'code', value: true },
        effects: [{ target: 'codeMore', value: true }],
        resultText: 'Ahhhh!',
      },
      {
        text: 'More coding!',
        condition: { target: 'codeMore', value: true },
        effects: [{ target: 'codeMax', value: true }],
        resultText: 'Yeah! Eat this!',
      },
      {
        text: 'Open Slack',
        effects: [{ target: 'openSlack', value: true }],
        resultText: 'Cats are dogs... Folgers is good... Fill this survey... Check.',
      },
      {
        text: 'Post cat video',
        condition: { target: 'openSlack', value: true },
        effects: [{ target: 'postCatVideo', value: true }],
        resultText: 'Meooowwww!',
      },
      {
        text: 'Give cable to Viet',
        condition: { target: 'getCable', value: true },
        effects: [{ target: 'helpViet', value: true }],
        resultText: 'Awesome! Now I can finally connect my 16 bit color keyboard to my machine! Swag!',
      },
    ],
    nextSpaces: [
      { name: 'lobby' },
      { name: 'managerSpace' },
      { name: 'birdBox' },
      { name: 'unrealKitchen' },
      { name: 'lunch', condition: { hours: 10, minutes: 40, target: 'eat', value: false } },
    ],
    texts: [
      'This is where the magic happens!',
      '"I\'m getting so hungry..." - Petteri',
      '"Hey, somebody going to make a Postmates order?" - Elton',
      '"High five!" - Will',
    ],
  },
  birdBox: {
    name: 'Bird Box',
    nextSpaces: [{ name: 'workingSpace' }],
    texts: ['It looks suspiciously quiet in here...'],
    tasks: [
      {
        text: "Hmm... There's a key lying on the floor. Take it!",
        condition: { target: 'emptyDishwasher', value: true },
        effects: [{ target: 'takeKey', value: true }],
        resultText: 'I wonder where this fits?',
      },
    ],
  },
  unrealKitchen: {
    name: 'Unreal Kitchen',
    tasks: [
      {
        text: 'Eat donuts',
        resultText: 'There are never too many donuts!',
      },
      {
        text: 'Eat salty liquorice',
        effects: [{ target: 'eatSaltyLiquorice', value: true }],
        resultText: 'Dude, what the shit? This is like... interesting.',
      },
      {
        text: 'Play arcade game',
        effects: [{ target: 'playArcadeGame', value: true }],
        resultText: 'HAHAHAHAHAHAHAAA!!!',
      },
      {
        text: 'Empty dishwasher',
        effects: [{ target: 'emptyDishwasher', value: true }],
        resultText: 'This will definitely make Rachel happy :)',
      },
      {
        text: 'Open storage room door',
        condition: { target: 'takeKey', value: true },
        effects: [{ target: 'getCable', value: true }],
        resultText: 'You found an interesting looking cable on the shelf and took it',
      },
    ],
    nextSpaces: [{ name: 'workingSpace' }, { name: 'exit' }],
    texts: ['Those plants look so real...'],
  },
  lunch: {
    name: 'Panda Express',
    tasks: [
      {
        text: 'Buy a bowl',
        condition: { target: 'eat', value: false },
        effects: [{ target: 'eat', value: true }],
        resultText: "Oh boy, my hunger is gone. Let's get back to work!",
      },
      {
        text: 'Buy a plate',
        condition: { target: 'eat', value: false },
        effects: [
          { target: 'eat', value: true },
          { target: 'takeLeftovers', value: true },
        ],
        resultText: 'Woah, that was some heavy shit! I even got some leftovers...',
      },
      {
        text: 'Buy a bigger plate!',
        condition: { target: 'eat', value: false },
        effects: [
          { target: 'eat', value: true },
          { target: 'takeLeftovers', value: true },
        ],
        resultText: "I'm dying right now! Whose idea was this anyway? At least I will make Elton happy...",
      },
    ],
    nextSpaces: [{ name: 'lobby', condition: { target: 'eat', value: true } }],
    texts: ['Welcome to Panda Express, how can I help you?'],
  },
  exit: {
    name: 'The Hallway from the Door',
  },
};

export const TARGETS = {
  playMusic: { value: false },
  makeCoffee: { value: false },
  drinkCoffee: {
    value: false,
    deadline: {
      hours: 11,
      minutes: 40,
      text: 'You run out of caffeine. Your brain and body stop functioning. This day was a disaster anyway...',
    },
  },
  eat: {
    value: false,
    deadline: {
      hours: 12,
      minutes: 0,
      text:
        'Petteri passes out in the middle of the office because of hunger. Rest in peace. How could you let this happen? :(',
    },
  },
  takeLeftovers: { value: false },
  feedElton: {
    value: false,
    deadline: {
      hours: 13,
      minutes: 0,
      text: 'Elton ate 5 hamburgers for lunch but got suddenly super hungry. He fades away... :(',
    },
  },
  eatSaltyLiquorice: { value: false },
  code: { value: false },
  codeMore: { value: false },
  codeMax: { value: false },
  openSlack: { value: false },
  postCatVideo: { value: false },
  playArcadeGame: { value: false },
  emptyDishwasher: {
    value: false,
    deadline: {
      hours: 14,
      minutes: 10,
      text: 'Dirty dishes... Dirty dishes! Rachel feels hopeless and falls into darkness...',
    },
  },
  takeKey: { value: false },
  getCable: { value: false },
  helpViet: { value: false },
  finishIt: {
    value: false,
    deadline: { hours: 16, minutes: 45, text: 'Your time is up... Where did you spend your whole day? Eating donuts?' },
  },
};

export const TARGET_WATCHES = [
  { target: 'drinkCoffee', value: true, hours: 10, minutes: 0, text: 'I really need some Folgers...', shown: false },
  {
    target: 'eat',
    value: true,
    hours: 11,
    minutes: 20,
    text: '"I\'m so hungry I could kill a horse!" - Petteri',
    shown: false,
  },
  {
    target: 'code',
    value: true,
    hours: 9,
    minutes: 20,
    text: "Maybe it's time for some coding?",
    shown: false,
  },
  {
    target: 'emptyDishwasher',
    value: true,
    hours: 13,
    minutes: 0,
    text: '"Would someone mind helping me with the dishes?" - Rachel',
    shown: false,
  },
  {
    target: 'helpViet',
    value: true,
    hours: 11,
    minutes: 0,
    text: '"Has anybody seen my keyboard cable?" - Viet',
    shown: false,
  },
];
